import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { startWith } from 'rxjs/operators';
import { TipoAltroSoggetto } from 'src/app/models/tipo-altro-soggetto';

@Component({
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  @Input() search: any;
  @Output() searchChange = new EventEmitter();

  constructor(
    private fb: FormBuilder,

  ) { }

  form: FormGroup;

  ngOnInit(): void {
    this.form = this.fb.group({
      denominazione: [this.search?.denominazione],
      nome: [this.search?.nome],
      cognome: [this.search?.cognome],
      via: [this.search?.via],
      civico: [this.search?.civico],
      comune: [this.search?.comune],
      tel: [this.search?.tel],
      fax: [this.search?.fax],
      cell: [this.search?.cell],
      email: [this.search?.email],
      tipo: [this.search?.tipo],
      partita_iva: [this.search?.partita_iva],
      codice_fiscale: [this.search?.codice_fiscale],
    });

    this.form.valueChanges.pipe(
      startWith(this.form.value)
    ).subscribe(v => this.searchChange.emit(this.trimDeep(v)));

  }

  private trimDeep(value: any): any {
    if (typeof value === 'string') {
      return value.trim();
    }
    if (Array.isArray(value)) {
      return value.map(v => this.trimDeep(v));
    }
    if (value && typeof value === 'object') {
      const result: any = {};
      Object.keys(value).forEach(key => {
        result[key] = this.trimDeep(value[key]);
      });
      return result;
    }
    return value;
  }
}
